export default [
  'Lang_en-eu',
  'Lang_cs-cz',
  'Lang_da-DK',
  'Lang_de-CH',
  'Lang_de-DE',
  'Lang_en-gb',
  'Lang_es-ES',
  'Lang_fi-FI',
  'Lang_fr-BE',
  'Lang_fr-FR',
  'Lang_hu-HU',
  'Lang_it-IT',
  'Lang_nl-BE',
  'Lang_nl-NL',
  'Lang_nn-NO',
  'Lang_pl-PL',
  'Lang_ru-RU',
  'Lang_sk-SK',
  'Lang_sv-SE',
  'Lang_lt-lt',
  'Lang_et-EE',
  'Lang_lv-LV',
  'Lang_ar-AE',
  'Lang_en-ZA',
  'Lang_pt-PT',
  'Lang_tr-TR',
  'Lang_ro-RO',
  'lang_en-TT',
  'lang_de-AT',
  'LoadMore',
  'Pitstop.ViewTheLeaderboard',
  'Pitstop.HideTheLeaderboard',
  'Pitstop.FilterBy',
  'Pitstop.Event',
  'Pitstop.SearchPlaceholder',
  'Pitstop.NothingFoundError',
  'Pitstop.Leaderboard.Rank',
  'Pitstop.Leaderboard.CultureRank',
  'Pitstop.Leaderboard.Name',
  'Pitstop.Leaderboard.Time',
  'Pitstop.Leaderboard.Trade',
  'Pitstop.Leaderboard.Country',
  'Pitstop.Leaderboard.EuropeanFinalists',
  'Pitstop.Leaderboard.SearchPlaceholder',
  'Pitstop.Leaderboard.FilterPlaceholder',
  'Pitstop.Leaderboard.All',
  'Pitstop.Leaderboard.Finalists',
  'Pitstop.Leaderboard.Region',
  'Pitstop.Map.SearchPlaceholder',
  'Pitstop.Map.From',
  'Pitstop.Map.To',
  'Pitstop.Map.Stand',
  'Pitstop.Leaderboard',
  'Pitstop.ViewLeaderboard',
  'Pitstop.Menu',
];
